import { Delete, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, Divider, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Slider, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import $carbon, { animalsMassAndNexcretion, pesticideTypes } from "../../../services/$carbon";
import SelectInput from "../../ui/SelectInput";
import { variables } from "../../../styles/abstract/variables";

function AnimalsForm(props) {
  const { model, setModel, nextStep, prevStep, climateZone } = props;

  const [local, setLocal] = useState({
    category: undefined,
    numberOfAnimals: undefined,
  });

  const createCategories = () => {
    let result = [];
    let object = animalsMassAndNexcretion;
    Object.keys(object).map((cat) => {
      result.push({ value: object[cat], label: cat });
    })
    return result
  }

  useEffect(() => {
    if(model.records.length > 0) {
      let total = $carbon.calculateAnimalsEmission(model.records, climateZone);
      console.log(total);
      setModel({ totalEmission: total});
    } else {
      setModel({totalEmission: undefined});
    }
  }, [JSON.stringify(model.records)]);

  const renderCategories = () => {
    if (model.records.length === 0) {
      return (
        <Grid item xs={12}>
          <Typography>No records</Typography>
        </Grid>
      )
    }

    return (
      <Grid item xs={12}>
        <List dense>
          {
            model.records.map((record, i) => (
              <ListItem className="co-background" key={i}>
                <ListItemText primary={record.category.name} secondary={`Number of animals: ${record.numberOfAnimals}`} />
                <ListItemSecondaryAction><IconButton onClick={() => setModel({records: model.records.filter((r,j) => j !== i)})} size="small" color="error"><Delete fontSize="small"/></IconButton></ListItemSecondaryAction>
              </ListItem>
            ))
          }
        </List>
      </Grid>
    )

  }

  const renderContent = () => {
    return (
      <Grid item xs={12}>
        <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
          <CardContent className="co-background" sx={{ padding: '40px' }}>
            <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <SelectInput name="Category" value={local.category} items={createCategories()} onChange={(e) => {setLocal( current => ({...current, category: e.target.value}))}} label="Category" variant="outlined" fullWidth size="small" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size="small" value={local.numberOfAnimals} onChange={(e) => setLocal(current => ({ ...current, numberOfAnimals: e.target.value }))} type="number" label="Number of animals" variant="outlined" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size="small" value={local.hours} onChange={(e) => setLocal(current => ({ ...current, hours: e.target.value }))} type="number" label="Total hours on the field" variant="outlined" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button disabled={!local.category || !local.numberOfAnimals || !local.hours} onClick={() => setModel({records: [...model.records, {...local}]})} variant="contained" >Add record</Button>
              </Grid>

              <Grid item xs={12}>
                <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
              </Grid>
              {renderCategories()}
            </Grid>
          </CardContent>
          <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
            <Button onClick={prevStep} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
            <Button onClick={nextStep} variant="contained" endIcon={<KeyboardArrowRight />}>Next</Button>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <Container>
      <Grid container spacing={2}>
        {renderContent()}
      </Grid>
    </Container>
  );
}

export default AnimalsForm;